import { $config } from '@client/core/atoms/config.js';
import { isFeatureEnabled } from '@client/core/atoms/unleashFeatures.js';
import {
  Brand,
  FinnLegendaryVertical,
  UNLEASH_FEATURE_NAME,
  Vertical
} from '@schibsted-nmp/advertising-shared';

const mobilityVerticals: Array<Vertical | FinnLegendaryVertical> = [
  Vertical.Mobility,
  FinnLegendaryVertical.Car,
  FinnLegendaryVertical.Boat,
  FinnLegendaryVertical.Mc,
  FinnLegendaryVertical.B2B,
  FinnLegendaryVertical.Atv,
  FinnLegendaryVertical.Scooter,
  FinnLegendaryVertical.Snowmobile
];

type BrandVerticalMap = Partial<
  Record<Brand, Array<Vertical | FinnLegendaryVertical>>
>;

const impactMetricVerticals: BrandVerticalMap = {
  dba: [Vertical.Recommerce],
  tori: [Vertical.Recommerce],
  blocket: [Vertical.Recommerce, Vertical.Realestate, ...mobilityVerticals],
  finn: [Vertical.Recommerce, Vertical.Realestate, ...mobilityVerticals]
};

export const isImpactMetricEnabled = () => {
  const vertical = $config.get()?.vertical;
  const brand = $config.get()?.brand;

  return (
    vertical !== undefined &&
    brand !== undefined &&
    impactMetricVerticals[brand]?.includes(vertical) &&
    isFeatureEnabled(UNLEASH_FEATURE_NAME.enablePulseEventsForAds)
  );
};
